import React from 'react';
import AppConfigurationService from '../../../services/app-configuration-service/app-configuration-service';
import {
    EU_CHAT_BOT_URLS,
    NEW_EU_HELP_ROUTER_MARKETS,
} from '../../../constants';

interface NewHelpRouterProps {
    currentLanguageRegionCode: string;
}
export const NewHelpRouter = (props: NewHelpRouterProps) => {
    const newHelpRouterMarket =
        NEW_EU_HELP_ROUTER_MARKETS.ford.supportedMarkets.find(
            (market) =>
                market.languageRegionCode.replace('_', '-') ===
                props.currentLanguageRegionCode
        );
    const { countryCode, languageRegionCode, isUrlWithBeta } =
        newHelpRouterMarket;

    const checkIsProd =
        process.env.REACT_APP_ACTIVE_PROFILE &&
        process.env.REACT_APP_ACTIVE_PROFILE === 'prod';

    const prodUrl = isUrlWithBeta
        ? `/content/guxeu-beta/${countryCode}/${languageRegionCode}/configuration/dse-app-configuration/dse-chatbot-configuration.model.json`
        : `/content/guxeu/${countryCode}/${languageRegionCode}/configuration/dse-app-configuration/dse-chatbot-configuration.model.json`;

    const preProdUrl = isUrlWithBeta
        ? `${EU_CHAT_BOT_URLS.DSE_CHAT_BOT_CONFIGURATION}/content/guxeu-beta/${countryCode}/${languageRegionCode}/configuration/dse-app-configuration/dse-chatbot-configuration.model.json`
        : `${EU_CHAT_BOT_URLS.DSE_CHAT_BOT_CONFIGURATION}/content/guxeu/${countryCode}/${languageRegionCode}/configuration/dse-app-configuration/dse-chatbot-configuration.model.json`;

    const chatBotAemUrl = () => {
        return checkIsProd ? prodUrl : preProdUrl;
    };

    return (
        <>
            <div
                className="host-container dse-chatbot"
                data-json-path={chatBotAemUrl()}
                data-is-author-edit-mode="false"
            />
        </>
    );
};
